import { Button } from "@mui/material";
import { useSetState } from "components/ReduxProvider";
import React from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router";
import { VERIFYTRANS } from "root/other/Verify";
import styled from "styled-components/macro";
import { VERIFY } from "../RootRouter.config";

const SVerifyButton = styled(Button)`
  color: #f44336;
  border-color: #f44336;
  box-shadow: 0 0 8px #f4433666;
  margin: 10px 0;
`;

type Props = {};

const VerifyButton: React.FC<Props> = () => {
  const navigate = useNavigate();
  const setInviteDialog = useSetState("inviteDialog");
  return (
    <SVerifyButton
      variant="outlined"
      onClick={(e) => {
        e.stopPropagation();
        navigate(VERIFY.url());
        setInviteDialog(false);
      }}
    >
      <Trans>{VERIFYTRANS}</Trans>
    </SVerifyButton>
  );
};

export default VerifyButton;
